import _, { createContext } from "react";

export const rootStoreContext = createContext();
export const staticContext = createContext();
export const stylesContext = createContext();
export const constantsContext = createContext();
export const pageLoadingContext = createContext();
